import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup } from '@angular/forms';



@Component({
  selector: 'app-appointmentstatus',
  templateUrl: './appointmentstatus.component.html',
  styleUrls: ['./appointmentstatus.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],

})
export class AppointmentstatusComponent implements OnInit {

  columnsToDisplay = ['id', 'name', 'notes'];
  headercolumnsToDisplay = ['Id', 'Name', 'Notes'];
  // dataSource = ELEMENT_DATA;
  //expandedElement: PeriodicElement | null;
  show: boolean;


  showInfo() {
    // this.popupVisible = true;
    this.show = !this.show;
  }


  Appointmentform: FormGroup;
  submitted = false;


  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.Appointmentform = this.formBuilder.group({

      id: ['',],
      name: ['',],
      select: ['',],
      inactive: ['',],
      cancel: ['',],
      change: ['',],
      notes: ['',],
      show: ['',],
      ids: ['',],
      names: ['',],
      selectt: ['',],
      inactivee: ['',],
      cancels: ['',],
      changecf: ['',],
      notess: ['',],
      showap: ['',],


    });
  }

  get f() { return this.Appointmentform.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.Appointmentform.invalid) {
      return;
    }

    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.Appointmentform.value))
  }
}
